import { getValue } from "@utils/lodash";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import "./otp.scss";
import LoginPageLyout from "@layouts/login";
import {
  GetSpecificOrganizationToken,
  resendLogiOTP,
  validateLoginOTP,
} from "@services/auth.service";
import { aesGcmEncrypt, getHmac } from "@_common/text-helpers";
import { config } from "../../../../env";
import { sanitizeInput } from "@_common/dompurify";

const OTP_INPUTS_PER_GROUP = 6; // Number of OTP inputs per group
function LoginOTP(props: any) {
  const params = useParams();
  const simpleValidator = useRef(new SimpleReactValidator());
  const inputRefs = useRef<any>([]); // Ref to store input references

  useEffect(() => {
    inputRefs.current[0].focus();
  }, []);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Array to store OTP digits
  const [, forceUpdate] = useState(0);
  /* -------------------------------------------------------------------------- */
  /*                                  API Section                               */
  /* -------------------------------------------------------------------------- */

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    let hashedRid = await getHash(localStorage.getItem("hash"));
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      setSubmitLoading(true);
      try {
        const enteredOtp = otp.join("");
        // const base64Otp = Buffer.from(enteredOtp).toString('base64');

        let obj = {
          mfa_token: params.token,
          mfa_otp: await aesGcmEncrypt(enteredOtp)
          // mfa_otp: btoa(enteredOtp),
          // mfa_otp: base64Otp, // Now sending base64 encoded OTP
        };
        let resp = await validateLoginOTP(obj);
        if (resp) {
          localStorage.removeItem("cn");
          localStorage.removeItem("hash");
          setSubmitLoading(false);
          localStorage.setItem(
            "accessToken",
            getValue(resp, `data.accessToken`, "")
          );
          localStorage.setItem(
            "refreshToken",
            getValue(resp, `data.refreshToken`, "")
          );
          localStorage.setItem(
            "user",
            JSON.stringify(getValue(resp, `data.user`, ""))
          );
          window.location.href = `/dashboard/self-compliance/compliance`;
          localStorage.removeItem("hash");
          if (getValue(resp, `data.user.org_id`, "")) {
            getData(
              getValue(resp, `data.user.org_id`, ""),
              getValue(resp, `data.accessToken`, "")
            );
          }
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  const getHash = async (id: any) => {
    return await getHmac(id, config.AUTH_SHARED_KEY);
  };

  const getData = async (id: string, token: string) => {
    try {
      let resp = await GetSpecificOrganizationToken(id, token);
      if (resp) {
        if (getValue(resp, `data.organisation_logo`, "")) {
          localStorage.setItem(
            "organisation_logo",
            getValue(resp, `data.organisation_logo`, "")
          );
        }
      }
    } catch (error) {}
  };

  const handleOtpInputChange = (groupIdx: any, digitIdx: any, value: any) => {
    const newOtp = [...otp];
    const globalDigitIdx = groupIdx * OTP_INPUTS_PER_GROUP + digitIdx;
    newOtp[globalDigitIdx] = value;
    setOtp(newOtp);

    const moveFocus = (moveIndex: any) => {
      if (moveIndex >= 0 && moveIndex < otp.length) {
        inputRefs.current[moveIndex].focus();
      }
    };

    if (value) {
      moveFocus(
        globalDigitIdx < otp.length - 1 ? globalDigitIdx + 1 : globalDigitIdx
      );
    } else {
      moveFocus(globalDigitIdx > 0 ? globalDigitIdx - 1 : globalDigitIdx);
    }
  };

  const handlePaste = async (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    try {
      const clipboardData =
        event.clipboardData || getValue(window, `clipboardData`, {});
      const pastedData = clipboardData.getData("text");
      if (pastedData) {
        const otpArray = pastedData
          .split("")
          .filter((char) => /\d/.test(char))
          .slice(0, otp.length);

        const newOtp = otpArray.map((digit, idx) => digit || "");
        setOtp(newOtp);
        // Set focus on the last input
        const lastInputIndex = newOtp.length - 1;
        if (inputRefs.current[lastInputIndex]) {
          inputRefs.current[lastInputIndex].focus();
        }
      } else {
        console.error("No text found in clipboard.");
      }
    } catch (error) {
      console.error("Error reading clipboard:", error);
    }
  };

  const resendOTP = async () => {
    try {
      let resp = await resendLogiOTP(getValue(params, `token`, ""));
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setOtp(["", "", "", "", "", ""]);
      }
    } catch (error) {}
  };
  return (
    <LoginPageLyout>
      <div className="m-auto form-wrapper__form">
        {" "}
        <div className={`back-link"cursor-pointer pt-3 back-arrow-wrapper`}>
          {/* <Link to="/login">
            <img
              src="/images/icons/back-icon.svg"
              className={`back-link-image"img-fluid`}
              alt="img"
            />
          </Link> */}
        </div>
        <div className="d-flex justify-content-center otp-login-page">
          <div className="login_card">
            <div className={`support-login-wrapper__details`}>
              <h4 className={"support-login-wrapper__title"}>
                OTP is sent on email
              </h4>
              <p className="mt-2">
                A 6-character OTP has been dispatched. It has a limited
                validity, so kindly input it promptly.
              </p>
              <div className={`custom-form-group"form-group mt-4`}>
                <div className="d-flex justify-content-between">
                  {[...Array(otp.length)].map((_, idx) => {
                    const groupIdx = Math.floor(idx / OTP_INPUTS_PER_GROUP);
                    const localIdx = idx % OTP_INPUTS_PER_GROUP;
                    return (
                      <React.Fragment key={idx}>
                        <input
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          pattern="\d{1}"
                          name={`otp-${idx}`}
                          onChange={(e) =>
                            handleOtpInputChange(
                              groupIdx,
                              localIdx,
                              sanitizeInput(e.target.value)
                            )
                          }
                          onPaste={handlePaste}
                          maxLength={1}
                          className={`otp-input`}
                          value={otp[idx]}
                          ref={(input) => (inputRefs.current[idx] = input)}
                        />
                        {/* {isLastInGroup && idx < otp.length - 1 && (
                          <span
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            className="mt-2"
                          >
                            _
                          </span>
                        )} */}
                      </React.Fragment>
                    );
                  })}
                </div>
                {simpleValidator && (
                  <p className={`form-error text-center`}>
                    {simpleValidator.current.message(
                      "OTP",
                      otp,
                      "required|number"
                    )}
                  </p>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={submitLoading}
                  className="form-cta-button__primary-btn mt-3"
                  type="submit"
                >
                  {submitLoading ? "Please wait..." : "Verify"}
                </button>

                <div className="mt-4" onClick={resendOTP}>
                  Not received your code?<a href="#0"> Resend Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoginPageLyout>
  );
}

export default LoginOTP;
